import { StyleSheet } from "@react-pdf/renderer";
import { ToWords } from "to-words";

export const layoutStyles = StyleSheet.create({
    flexBetween: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
    },
    flexCenter: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
});

export const textStyles = StyleSheet.create({
    arabicText: {
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        fontFamily: "ArabicFont",
    },
});

export const color = {
    brand: "#ff9500",
    bg: "#f2f2f2",
};

export const toWords = new ToWords({
    converterOptions: {
        currency: true,
        ignoreDecimal: false,
        ignoreZeroCurrency: false,
        doNotAddOnly: false,
        currencyOptions: {
            name: "Riyal",
            plural: "Riyals",
            symbol: "SAR",
            fractionalUnit: {
                name: "Halala",
                plural: "Halalas",
                symbol: "",
            },
        },
    },
});
